import { UserRole, UserRoleType } from "auth/UserRole";
import { APICommonResponse, ApiId, HttpMethod, makeParam, request } from ".";
import { getUrl } from "./url";

export type Me = {
  id: string;
  name: string;
  email: string;
  role: UserRoleType;
  shop_id: string | null;
  switched_user_id: string | null;
  switched_name: string | null;
  switched_role: UserRoleType | null;
};

type MeResponse = {
  data: Me;
} & APICommonResponse;

export const csrfToken = async () => {
  await request({
    url: getUrl(ApiId.CSRF_TOKEN),
    method: HttpMethod.GET,
  });
};

export const me = async () => {
  const res = await request<MeResponse>({
    url: getUrl(ApiId.ME),
    method: HttpMethod.GET,
  });
  return res;
};

export const login = async (param: { email: string; password: string }) => {
  const res = await request({
    url: getUrl(ApiId.LOGIN),
    method: HttpMethod.POST,
    data: param,
  });
  return res;
};

export const logout = async () => {
  const res = await request({
    url: getUrl(ApiId.LOGOUT),
    method: HttpMethod.GET,
  });
  return res;
};

// -------顧客成り代わり開始---------------
export type 顧客成り代わり開始Request = {
  user_id: string;
};
export type 顧客成り代わり開始Response = {
  data: {
    user_id: string;
    name: string;
    role: string;
  };
} & APICommonResponse;
export const 顧客成り代わり開始 = async (param: 顧客成り代わり開始Request) => {
  const res = await request<顧客成り代わり開始Response>({
    url: getUrl(ApiId.顧客成り代わり開始),
    method: HttpMethod.POST,
    data: makeParam(param),
  });
  return res;
};
// -------店舗成り代わり開始---------------
export type 店舗成り代わり開始Request = {
  user_id: string;
};
export type 店舗成り代わり開始Response = {
  data: {
    user_id: string;
    name: string;
    role: string;
  };
} & APICommonResponse;
export const 店舗成り代わり開始 = async (param: 店舗成り代わり開始Request) => {
  const res = await request<店舗成り代わり開始Response>({
    url: getUrl(ApiId.店舗成り代わり開始),
    method: HttpMethod.POST,
    data: makeParam(param),
  });
  return res;
};

// -------成り代わり終了---------------
export type 成り代わり終了Request = {};
export type 成り代わり終了Response = {} & APICommonResponse;
export const 成り代わり終了 = async (param: 成り代わり終了Request) => {
  const res = await request<成り代わり終了Response>({
    url: getUrl(ApiId.成り代わり終了),
    method: HttpMethod.GET,
    data: new URLSearchParams(param),
  });
  return res;
};

export type MeUpdateRequest = {
  name: string;
};
export type MeUpdateResponse = {
  data: Me;
} & APICommonResponse;
export const updateMe = async (param: MeUpdateRequest) => {
  const res = await request<MeUpdateResponse>({
    url: getUrl(ApiId.ME_UPDATE),
    method: HttpMethod.POST,
    data: param,
  });
  return res;
};

export type EmailChangeRequestRequest = {
  new_email: string;
};
export const requestEmailChange = async (param: EmailChangeRequestRequest) => {
  const res = await request({
    url: getUrl(ApiId.EMAIL_CHANGE_REQUEST),
    method: HttpMethod.POST,
    data: param,
  });
  return res;
};

export type EmailChangeVerifyRequest = {
  token: string;
};
export const verifyEmailChange = async (param: EmailChangeVerifyRequest) => {
  const res = await request({
    url: getUrl(ApiId.EMAIL_CHANGE_VERIFY),
    method: HttpMethod.POST,
    data: param,
  });
  return res;
};

// -------パスワードリセット---------------
export type PasswordResetRequestRequest = {
  email: string;
};
export const passwordResetRequest = async (param: PasswordResetRequestRequest) => {
  const res = await request({
    url: getUrl(ApiId.PASSWORD_RESET_REQUEST),
    method: HttpMethod.POST,
    data: param,
  });
  return res;
};

export type PasswordResetVerifyRequest = {
  token: string;
};
export const passwordResetVerify = async (param: PasswordResetVerifyRequest) => {
  const res = await request({
    url: getUrl(ApiId.PASSWORD_RESET_VERIFY),
    method: HttpMethod.POST,
    data: param,
  });
  return res;
};

export type PasswordResetExecuteRequest = {
  token: string;
  password: string;
};
export const passwordResetExecute = async (param: PasswordResetExecuteRequest) => {
  const res = await request({
    url: getUrl(ApiId.PASSWORD_RESET_EXECUTE),
    method: HttpMethod.POST,
    data: param,
  });
  return res;
};

// -------APIトークン発行---------------
export type TokenCreateRequest = {};
export type TokenCreateResponse = {
  data: {
    token: string;
  };
} & APICommonResponse;
export const tokenCreate = async (param: TokenCreateRequest) => {
  const res = await request<TokenCreateResponse>({
    url: getUrl(ApiId.TOKEN_CREATE),
    method: HttpMethod.POST,
    data: param,
  });
  return res;
};
